import React from 'react';

export default class VesselHeader extends React.Component {
  renderVesselNames(vessel) {
    if (Array.isArray(vessel)) {
      return vessel.map(item => item.name).join(' ');
    }

    return vessel.name;
  }

  render() {
    const vessel = this.props.vessel;
    return (
      <div className="vesselheader">
        <div className="vesselheader__text">
          <p>
            <strong>{this.renderVesselNames(vessel)}</strong>
          </p>
          <button className="vesselheader__text__infobtn" onClick={this.props.onOpenInfo}>
            Full vessel info
          </button>
        </div>
        <img className="vesselheader__image" src={vessel.imgsrc} alt={vessel.name} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/vesselheader.js